import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { format } from "date-fns";
import React, {
    useEffect,
    useState,
    useImperativeHandle,
    forwardRef,
} from "react";
import Button from "react-bootstrap/Button";
import {
    ASSET_CONFIG_URL,
    ASSET_CONFIG_BY_AI_URL,
} from "./../../Constants/Constants";
import AxiosInstance from "./../../services/AxiosInstance";
import { useAlert } from "./../alerts/AlertContext";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";

function AssetConfiguration({ editAssetId, selectedAssetName }, ref) {
    const globaltheme = useTheme();
    const theme = createTheme({
        ...globaltheme,
        components: {
            MuiSelect: {
                defaultProps: {
                    sx: {
                        paddingLeft: "20px",
                    },
                },
            },
            MuiButton: {
                defaultProps: {
                    sx: {
                        marginTop: 2,
                        marginBottom: 2,
                        display: "block",
                    },
                },
            },
        },
    });

    const [id, setId] = useState("");
    const [assetItem, setAssetItem] = useState({});
    const [osVersion, setOsVersion] = useState("");
    const [ipAddress, setIpAddress] = useState("");
    const [processor, setProcessor] = useState("");
    const [ram, setRam] = useState("");
    const [storage, setStorage] = useState("");
    const [description, setDescription] = useState("");

    const showAlert = useAlert();

    const [assetConfig, setAssetConfig] = useState({
        id: "",
        osVersion: "",
        ipAddress: "",
        processor: "",
        ram: "",
        storage: "",
        description: "",
        assetItem: { id: "" },
    });

    useEffect(() => {
        getAssetConfig();
    }, []);

    const handleOSVersionChange = (event) => {
        setOsVersion(event.target.value);
    };

    const handleIPAddressChange = (event) => {
        setIpAddress(event.target.value);
    };

    const handleProcessorChange = (event) => {
        setProcessor(event.target.value);
    };

    const handleRamChange = (event) => {
        setRam(event.target.value);
    };

    const handleStorageChange = (event) => {
        setStorage(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (id !== "") assetConfig.id = id;

        assetConfig.osVersion = osVersion;
        assetConfig.ipAddress = ipAddress;
        assetConfig.processor = processor;
        assetConfig.ram = ram;
        assetConfig.storage = storage;
        assetConfig.description = description;
        assetConfig.assetItem = { id: editAssetId };

        AxiosInstance.post(ASSET_CONFIG_URL, assetConfig)
            .then((response) => {
                showAlert(
                    "Asset Configuration created successfully!",
                    "success"
                );
                getAssetConfig();
            })
            .catch((error) => {
                showAlert("Asset Configuration creation failed!", "error");
                console.error(error);
            });
    };

    const getAssetConfig = () => {
        AxiosInstance.get(ASSET_CONFIG_BY_AI_URL + editAssetId)
            .then((response) => {
                var assetConfig = response.data;
                setId(assetConfig?.id);
                setAssetItem(assetConfig.assetItem);
                setOsVersion(assetConfig.osVersion);
                setIpAddress(assetConfig.ipAddress);
                setProcessor(assetConfig.processor);
                setRam(assetConfig.ram);
                setStorage(assetConfig.storage);
                setDescription(assetConfig.description);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 404) {
                        console.error("Resource not found (404)");
                        //setAddress("");
                    } else {
                        console.error(
                            "Server responded with error:",
                            error.response.status
                        );
                    }
                } else if (error.request) {
                    console.error("No response from server");
                } else {
                    console.error("Axios error:", error.message);
                }
            });
    };

    useImperativeHandle(ref, () => ({
        submit: (event) => handleSubmit(event || { preventDefault: () => {} }),
    }));

    return (
        <ThemeProvider theme={theme}>
            <Box
                component="form"
                sx={{ "& .MuiTextField-root": { m: 1 } }}
                noValidate
                autoComplete="off"
            >
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="OS Version"
                            label="OS Version"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={osVersion}
                            onChange={handleOSVersionChange}
                        />
                    </Grid>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="IPAddress"
                            label="IP Address"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={ipAddress}
                            onChange={handleIPAddressChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Processor"
                            label="Processor"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={processor}
                            onChange={handleProcessorChange}
                        />
                    </Grid>
                    <Grid
                        size={8}
                        style={{
                            marginTop: "auto",
                            paddingBottom: "7px",
                            paddingLeft: "7px",
                        }}
                    >
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Ram"
                            label="Ram"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={ram}
                            onChange={handleRamChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Storage"
                            label="Storage"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={storage}
                            onChange={handleStorageChange}
                        />
                    </Grid>
                    <Grid
                        size={8}
                        style={{
                            marginTop: "auto",
                            paddingBottom: "7px",
                            paddingLeft: "7px",
                        }}
                    ></Grid>
                </Grid>

                <TextField
                    autoFocus
                    id="outlined-multiline-static"
                    name="description"
                    label="Description"
                    placeholder="Enter Description"
                    fullWidth
                    multiline
                    rows={4}
                    cols={10}
                    value={description}
                    onChange={handleDescriptionChange}
                />
            </Box>
        </ThemeProvider>
    );
}

export default forwardRef(AssetConfiguration);
